import React from 'react';

import { di } from 'react-magnetic-di';

import { Text } from '@atlaskit/primitives/compiled';

import { asFormTextField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const ViewParagraphPlainInput = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formTextField = asFormTextField(formField);

	if (formTextField === undefined) {
		return <></>;
	}

	return (
		<Text testId={`field-input-paragraph-plain-view-${fieldId}`}>{formTextField.value?.text}</Text>
	);
};
